const FooterSection = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#111D33] text-white/70">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-white/10">

          {/* 브랜드 소개 */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/046fff3eb93c7b920ea9980217e91d56/5c83bcb87925a77a3e85b4a671cd71a8.png"
              alt="Smart Cap"
              className="h-14 w-auto object-contain mb-4 brightness-200"
            />
            <p className="text-white font-bold text-lg mb-1">스마트캡 (Smart Cap)</p>
            <p className="text-[#FF6B35] text-sm font-medium mb-4">"방수도 시공도 한 번에"</p>
            <p className="text-sm leading-relaxed mb-5">
              실리콘 패킹 일체형 지붕 마감캡으로 샌드위치패널 지붕 시공의<br className="hidden md:block" />
              누수 문제를 근본적으로 해결합니다.
            </p>
            <div className="inline-flex items-center gap-2 bg-[#FF6B35]/10 border border-[#FF6B35]/20 px-3 py-1.5 rounded-full">
              <i className="ri-award-fill text-[#FF6B35] text-xs" />
              <span className="text-[#FF6B35] text-xs font-medium">
                특허 출원 완료 · 10-2024-0173136
              </span>
            </div>
          </div>

          {/* 바로가기 */}
          <div>
            <p className="text-white font-semibold text-sm mb-4">바로가기</p>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: '제품 소개', id: 'hero' },
                { label: '핵심 기술', id: 'solution' },
                { label: '제품 비교', id: 'comparison' },
                { label: '제품 스펙', id: 'specs' },
                { label: '활용 분야', id: 'usecases' },
                { label: '견적 문의', id: 'cta' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-sm text-white/60 hover:text-[#FF6B35] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 연락처 */}
          <div>
            <p className="text-white font-semibold text-sm mb-4">연락처</p>
            <ul className="flex flex-col gap-3">
              {[
                { icon: 'ri-phone-fill', text: '010-8640-3977' },
                { icon: 'ri-mail-fill', text: 'myhomeis3977@hanmail.net' },
                { icon: 'ri-map-pin-fill', text: '경기도 광명시 금하로 458, 812호' },
                { icon: 'ri-time-fill', text: '평일 09:00 ~ 18:00' },
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-2.5">
                  <i className={`${item.icon} text-[#FF6B35] text-sm mt-0.5 flex-shrink-0`} />
                  <span className="text-sm leading-snug">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 하단 저작권 */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            © 2026 Smart Cap. All rights reserved.
          </p>
          <p className="text-xs text-white/40">
            특허출원번호: 10-2024-0173136 &nbsp;|&nbsp; 대표: 김창중 &nbsp;|&nbsp; 사업자등록번호: (직접 입력)
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
